import postFormTo from "./post-form";
import showFormError from "./form-error-dialog";
export default function clubArea() {

    // Permette di usare un underscore "_" nelle stringhe per andare a capo
    function tspace(s) {
        return s.replace("_", "\r\n");
    }

    // A.Scapin: funzione che inizializza il validator dei 2 form "Area Club"
    if (typeof window.initFormsValid2 === 'undefined') {
        window.initFormsValid2 = function (validator_url, login_url, post_page_url, internal_page_url, map_page_url, pdf_page_url) {
            $('#login-form').submit(function (event) {
                var isOkToGo = true;
                event.preventDefault();

                $('.page-loader').addClass('show'); // mostra loader

                // rimuove tutte le indicazioni di errore
                $('#errlogin').html('');
                $('#login-form').find('.field-error').removeClass("field-error");

                if (isOkToGo) {
                    // Il captcha è sempre obbligatorio: il token viene verificato lato server
                    window.executeRecaptchaProcess($('#login-form')[0], function (token) {
                        $.ajax({
                            type: 'POST',
                            url: login_url,
                            data: $('#login-form').serialize(),
                            success: function (response) {
                                if (!response.status) {
                                    showFormError(response.message, $('#errlogin'));
                                    $('.page-loader').removeClass('show'); // nasconde eventuale loader
                                    $('#login-form').find('button[type="submit"]').prop('disabled', false);
                                    return false;
                                }
                                // All OK go!
                                // check if there is main page url to redirect
                                switch (response.page) {
                                    case 'map': internal_page_url = map_page_url.length ? map_page_url : internal_page_url ;
                                        break;
                                    case 'pdf': internal_page_url = pdf_page_url.length ? pdf_page_url : internal_page_url;
                                        break;
                                    default:
                                }
                                // la sessione è già nel cookie: la pagina interna non legge i dati del form (email e password non vanno reinviati)
                                window.location.href = internal_page_url;
                            },
                            error: function () {
                                $('.page-loader').removeClass('show');
                                $('#login-form').find('button[type="submit"]').prop('disabled', false);
                            }
                        });
                    });
                }

            });

            $('#register-form').submit(function (event) {
                event.preventDefault();

                // rimuove tutte le indicazioni di errore
                $('#errregister').html('');
                $('#register-form').find('.field-error').removeClass("field-error");

                // campi obbligatori e spunte privacy: validazione nativa del browser (attributo required)
                var isOkToGo = true;

                if (isOkToGo) {
                    var $form = $('#register-form');

                    // Definiamo la funzione di invio AJAX per non ripeterla
                    var proceedToAjax = function() {
                        $('.page-loader').addClass('show');
                        $.ajax({
                            type: 'POST',
                            url: validator_url,
                            data: $form.serialize(),
                            success: function (response) {
                                if (!response.status) {
                                    $('.page-loader').removeClass('show');
                                    $form.find('button[type="submit"]').prop('disabled', false);
                                    $('#errregister').html(response.message).fadeIn();
                                    $('#' + response.field).addClass('field-error');
                                    return false;
                                }
                                // prima: $.redirect(url, $form.serialize()) inviava un campo per carattere (vuole un oggetto, non una stringa)
                                postFormTo(post_page_url, $form[0]);
                            },
                            error: function() {
                                $('.page-loader').removeClass('show');
                                $form.find('button[type="submit"]').prop('disabled', false);
                            }
                        });
                    };

                    // Il captcha è sempre obbligatorio: il token viene verificato lato server
                    window.executeRecaptchaProcess($form[0], function(token) {
                        proceedToAjax();
                    });
                }
            });

        }
    }

    // A.Scapin: funzione che esegue il LOGOUT dall'Area Club
    if (typeof window.initAC2 === 'undefined') {
        window.initAC2 = function (logout_url, message_page_url, logoutMessage, errorMessage) {
            if ($('#logoutbtn').length) {
                $('#logoutbtn').click(function () {
                    $('.page-loader').addClass('show'); // mostra loader

                    $.ajax({
                        type: 'POST',
                        url: logout_url,
                        data: 0,
                        success: function (response) {
                            $('.page-loader').removeClass('show'); // nasconde eventuale loader
                            if (response.status) {
                                // All OK go!
                                $.redirect(message_page_url, {formname: 'logout'});
                            } else {
                                alert(errorMessage);
                            }
                        }
                    });
                });
            }
        }
    }

    if (typeof window.initializeSectionInfiniteScroll === 'undefined') {
        window.initializeSectionInfiniteScroll = function (myACurl) {

            //* A.Scapin: variabili e funzioni necessarie alla ricerca dell'Area Club
            var searchTextSubmit = document.querySelector('#search_text_submit');
            var searchText = document.querySelector('#search_text');
            var searchSelectType = document.querySelector('#search_select_tipologie');
            var searchSelectYears = document.querySelector('#search_select_anni');

            window.ACsearchUrl = myACurl;

            let infScroll = new InfiniteScroll('.press-list', {
                path: '.pagination__next',
                append: '.press-list .item',
                history: false,
                status: '.page-load-status',
                hideNav: '.pagination'
            });

            if (searchTextSubmit) {
                searchTextSubmit.addEventListener('click', function (e) {
                    e.preventDefault();
                    search_text();
                    return false;
                });
            }

            if (searchText) {
                searchText.addEventListener("keypress", function (event) {
                    if (event.key === "Enter") {
                        event.preventDefault();
                        search_text();
                    }
                });
            }

            if (searchSelectType) {
                searchSelectType.addEventListener("change", search_select);
            }
            if (searchSelectYears) {
                searchSelectYears.addEventListener("change", search_select);
            }

            //textbox
            function search_text() {
                var testo_cercato = searchText.value;
                var tipo = searchSelectType.value;
                var anno = searchSelectYears.value;
                if (!tipo || tipo.length <= 0) {
                    tipo = 'all';
                }
                if (!anno || anno.length <= 0) {
                    anno = 'all';
                }
                const urlParams = new URLSearchParams(window.location.search);

                if ((testo_cercato && testo_cercato.length > 0) || (urlParams.get('ackw').length > 0)) {
                    if (window.ACsearchUrl.indexOf("?") > -1) {
                        location = window.ACsearchUrl + "&ackw=" + encodeURIComponent(testo_cercato) + "&actp=" + tipo + "&acyr=" + anno;
                    } else {
                        location = window.ACsearchUrl + "?ackw=" + encodeURIComponent(testo_cercato) + "&actp=" + tipo + "&acyr=" + anno;
                    }
                } else {
                    return false;
                }
            }

            //select
            function search_select() {
                var testo_cercato = searchText.value;
                var tipo = searchSelectType.value;
                var anno = searchSelectYears.value;
                if (!tipo || tipo.length <= 0) {
                    tipo = 'all';
                }
                if (!anno || anno.length <= 0) {
                    anno = 'all';
                }
                if (window.ACsearchUrl.indexOf("?") > -1) {
                    location = window.ACsearchUrl + "&ackw=" + encodeURIComponent(testo_cercato) + "&actp=" + tipo + "&acyr=" + anno;
                } else {
                    location = window.ACsearchUrl + "?ackw=" + encodeURIComponent(testo_cercato) + "&actp=" + tipo + "&acyr=" + anno;
                }
            }
        }
    }

    const resetPwdParams = typeof window.cdbResetPwdParams !== "undefined" ? window.cdbResetPwdParams : {};

    if ($('#reset-pwd-form').length) {
        const reset_password_url = resetPwdParams.reset_password_url || '';
        // clubArea() viene eseguita più volte (avvio e init di pagina): off/on evita gestori doppi e invii doppi
        $('#reset-pwd-form').off('submit.cdbReset').on('submit.cdbReset', function (event) {
            var isOkToGo = true,
                form = $('#reset-pwd-form'),
                errorMsg = $('#errReset'),
                pageLoader = $('.page-loader');
            event.preventDefault();

            pageLoader.addClass('show'); // mostra loader

            // rimuove tutte le indicazioni di errore
            errorMsg.html('');
            form.find('.field-error').removeClass("field-error");

            if (isOkToGo) {
                // Il captcha è sempre obbligatorio: il token viene verificato lato server
                window.executeRecaptchaProcess(form[0], function (token) {
                    $.ajax({
                        type: 'POST',
                        url: reset_password_url,
                        data: {email: $('#username').val(), lang: resetPwdParams.lang || '', 'g-recaptcha-response': token || ''},
                        success: function (response) {
                            if (!response.status) {
                                showFormError(response.message, errorMsg);
                                pageLoader.removeClass('show'); // nasconde eventuale loader
                                form.find('button[type="submit"]').prop('disabled', false);
                                return false;
                            }
                            // All OK go!
                            form.html('');
                            form.closest('.inner').find('.title-wrapper .color-secondary').hide(); // il sottotitolo descrive il form appena tolto
                            $('#reset-pwd-form-response').html(response.message);

                            pageLoader.removeClass('show'); // nasconde eventuale loader
                        },
                        error: function () {
                            pageLoader.removeClass('show');
                            form.find('button[type="submit"]').prop('disabled', false);
                        }
                    });
                });
            }
        });
    }

    // Conferma reset password dal link ricevuto via email
    if ($('#reset-pwd-confirm-form').length) {
        // off/on: vedi #reset-pwd-form (il link di reset vale una sola volta, un secondo invio risulterebbe "non valido")
        $('#reset-pwd-confirm-form').off('submit.cdbResetConfirm').on('submit.cdbResetConfirm', function (event) {
            var form = $('#reset-pwd-confirm-form'),
                errorMsg = $('#errResetConfirm'),
                pageLoader = $('.page-loader');
            event.preventDefault();

            pageLoader.addClass('show'); // mostra loader
            errorMsg.html('');

            // Il captcha è sempre obbligatorio: il token viene verificato lato server
            window.executeRecaptchaProcess(form[0], function (token) {
                $.ajax({
                    type: 'POST',
                    url: resetPwdParams.confirm_reset_password_url || '',
                    data: {
                        u: form.find('input[name="u"]').val(),
                        k: form.find('input[name="k"]').val(),
                        lang: resetPwdParams.lang || '',
                        'g-recaptcha-response': token || ''
                    },
                    success: function (response) {
                        pageLoader.removeClass('show'); // nasconde eventuale loader
                        if (!response.status) {
                            showFormError(response.message, errorMsg);
                            form.find('button[type="submit"]').prop('disabled', false);
                            return false;
                        }
                        // All OK go!
                        form.html('');
                        form.closest('.inner').find('.title-wrapper .color-secondary').hide(); // il sottotitolo descrive il form appena tolto
                        $('#reset-pwd-form-response').html(response.message);
                    },
                    error: function () {
                        pageLoader.removeClass('show');
                        form.find('button[type="submit"]').prop('disabled', false);
                    }
                });
            });
        });
    }
}